<template>
    <v-container class="datatabelOverviewProduct pa-0">
        <ProductResultRasterNavigation layoutVersion="1" v-if="pagData.totalCount > tableOptions.page_size" :tableOptions="tableOptions" :pagData="pagData"/>
        <v-data-table-server
            :headers="headers"
            fixed-header
             height="70vh"
             density="compact"
            :items="articleResultsData"
            :items-per-page=tableOptions.page_size
            :page=tableOptions.page
            :items-length=props.pagData.totalCount
            :items-per-page-text="dataAll.getStatic('product_pag_items_per_page','Items per page')"
            :page-text=pageText
            :no-data-text="dataAll.getStatic('product_pag_no_results_found','No results found')"
            :no-results-text="dataAll.getStatic('product_pag_no_results_found','No results found')"
            @update:options="loadPAGWithOptions"

            v-model:sort-by="sortBy"
            @click:row="onRowClick">



            <!-- first colum: with nuxt-link -->
            <template v-if="firstColumnSlotName" v-slot:[firstColumnSlotName]="{ item }">
                <nuxt-link
                    v-if="item['Link']"
                    class="text-decoration-none"
                    :to="item['Link']"
                    @click.stop>
                    <span v-html="item[headers[0]?.key]" />
                </nuxt-link>
                <span v-else v-html="item[headers[0]?.key]" />
            </template>

            <!-- other colums: html parsen -->
            <template
                v-for="header in headers.slice(firstColumnSlotName ? 1 : 0)"
                :key="header.key"
                v-slot:[`item.${header.key}`]="{ item }">
                <span v-html="item[header.key]" />
            </template>

            <template #bottom>
            <div class="v-data-table-footer">
                <div class="v-data-table-footer__items-per-page">
                <span>{{ dataAll.getStatic('product_pag_items_per_page', 'Items per page') }}</span>
                <v-select
                    :model-value="tableOptions.page_size"
                    :items="$PAG.itemPerPageOptions()"
                    :menu-props="selectOptionsWhiteBackground"
                    density="compact"
                    variant="outlined"
                    hide-details
                    @update:model-value="onItemsPerPageChange"
                />
                </div>

                <div class="v-data-table-footer__info">
                <div>{{ pageText }}</div>
                </div>

                <div class="v-data-table-footer__pagination">
                <ProductResultRasterNavigation
                    v-if="pagData.totalCount > tableOptions.page_size"
                    :tableOptions="tableOptions"
                    :pagData="pagData"
                    layoutVersion="2"
                />
                </div>
            </div>
            </template>
        </v-data-table-server>

    </v-container>

</template>





<script setup>
import { useRouter } from 'vue-router'
import ProductResultRasterNavigation from "@/components/Products/PAG/ProductResultRasterNavigation.vue";
const router = useRouter()
const dataAll = useDataAll()
const { $PAG } = useNuxtApp()
const DEFAULT_ITEMS_PER_PAGE = $PAG.defaultItemsPerPage()
const props = defineProps({
    pagData: {
        type: Object,
        default: {},
    },

    pageItem: {
        type: Object,
        default: "",
    },
});
// Reactive options for page and sorting
const tableOptions = reactive({
    page: 1, // always start op page 1
    sortBy: [],
    page_size:DEFAULT_ITEMS_PER_PAGE, // Standard items per page


});
let sortBy = ref([]);
const tableData = computed(() => props.pagData);
function onItemsPerPageChange(value) {
  $PAG.updateFilter($PAG.selectFilterValueByUrl(), {
    page_nr: null,  // back to page 1 — the current page may no longer exist
    page_size: value != DEFAULT_ITEMS_PER_PAGE ? value : null,
    sort: sortBy.value[0]?.key ?? null,
    direction: sortBy.value[0]?.order ?? null,
  })
}
const headerUnitLookup = computed(() => {
  const headers = props.pageItem?.Selector?.[0]?.Header ?? [];
  return headers.reduce((acc, header) => {
    acc[header.AttribuutSelectorName] = header.Unit;
    return acc;
  }, {});
});

// generate string item table
const pageText = computed(() => {
  const start = Number((tableOptions.page - 1) * tableOptions.page_size) + 1;
  const end = Math.min(
    start + Number(tableOptions.page_size) - 1,
    Number(props.pagData.totalCount)
  );
  const fromString = dataAll.getStatic('product_pag_table_from','from')
  return `${start}–${end} ${fromString} ${props.pagData.totalCount}`;
});

// retrieve url parameters
const selectedFilters = $PAG.selectFilterValueByUrl()
// get table headers
const headers = computed(() => {
  const headerArray = props.pageItem?.Selector?.[0]?.Header ?? [];
  return [...headerArray]
    .sort((a, b) => a.Number - b.Number) // Sort on number
    .map((headerObj, index) => ({
      title: headerObj.Name  ,
      key: headerObj.AttribuutSelectorName,
    }));
});


// set column headers searching
setSortHeaders()

// kolom slotname first entry
const firstColumnSlotName = computed(() => {
    const key = headers.value?.[0]?.key
    return key ? `item.${key}` : null
});

// get article results
const articleResultsData = computed(() => {

    let formattedArticles = [];

    // Check if tableData and tableData products are defined and have data
    if (tableData.value && tableData.value.products) {
        const articlesArray = Object.values(tableData.value.products);

        articlesArray.forEach((article) => {
            let entry = {}

            props.pageItem?.Selector?.[0].Header.forEach((header, index) => {
                const key = header.AttribuutSelectorName;
                if (index === 0 ){
                    entry[key] = article.SelectorValues?.[key]?.value ?? article.Head.ArticleNumber;

                } else {
                    entry[key] = article.SelectorValues?.[key]?.value + (headerUnitLookup.value[key]?" "+headerUnitLookup.value[key]:"") ?? "" ;
                }
            });
            entry['Link'] = $PAG.formatArticleUrl(article)
            formattedArticles.push(entry)

        });
    }

    tableOptions.page = selectedFilters.page_nr ? selectedFilters.page_nr : 1;
    tableOptions.page_size = selectedFilters.page_size ? selectedFilters.page_size : DEFAULT_ITEMS_PER_PAGE;

    return formattedArticles;
})
// Paginating or sorting, reload table with server input.
async function loadPAGWithOptions({ page, itemsPerPage, sortBy }) {
    const scrollY = typeof window !== 'undefined' ? window.scrollY : null

    $PAG.updateFilter($PAG.selectFilterValueByUrl(),
        {
            page_nr: page != 1 ? page : null,
            page_size: itemsPerPage != DEFAULT_ITEMS_PER_PAGE ? itemsPerPage : null,
            sort: sortBy[0] && sortBy[0].key ? sortBy[0].key : null,
            direction: sortBy[0] && sortBy[0].order ? sortBy[0].order : null
        }
    )

    if (typeof window !== 'undefined') {
        await nextTick()
        setTimeout(() => {
            window.scrollTo({ top: scrollY, behavior: 'instant' })
        }, 100)
    }
}
// navigate to product
function onRowClick(event, { item }) {
  if (item['Link']) {
    router.push(item['Link'])
  }
}

function setSortHeaders() {
    if (selectedFilters.sort && selectedFilters.sort != "") {
        sortBy.value = [{ key: selectedFilters.sort, order: selectedFilters.direction }]
    } else {
        sortBy.value = [] //default sorting on the serverside by article_number
    }
}
</script>